.safe {
    display: block;
}

.safe.inline {
    display: contents;
}

.top {
    padding-top: env(safe-area-inset-top, 0px);
}

.right {
    padding-right: env(safe-area-inset-right, 0px);
}

.bottom {
    padding-bottom: env(safe-area-inset-bottom, 0px);
}

.left {
    padding-left: env(safe-area-inset-left, 0px);
}
